import React from 'react'
import PropTypes from 'prop-types'

import { useSelector, useDispatch } from 'react-redux'

import useStyles from './searchlight.style'

import Image from '@components/image/image.component'
import ScenarioActionItem from '@components/searchlight-action-item/searchlight-action-item.component'

import { Carousel } from '@omnilert/components'

import dayjs from 'dayjs'
import { useIntl } from 'react-intl'

import { SEARCHLIGHT_CONFIRM_MODAL_OPEN } from '@actions/types'

const SearchLight = (props) => {
  const classes = useStyles(props)
  const { message } = props
  const { collection, documentId } = message
  
  const intl = useIntl()

  const dispatch = useDispatch()

  const document = useSelector(({ firestore: { data } }) => data[collection] && data[collection][documentId])

  if (!document) return null

  const { actionTaken, body, createdAt, actions, media, subtitle, title } = document
  const { images } = media
  const { seconds } = createdAt
  const milliseconds = seconds * 1000

  const onClickAction = action => {
    dispatch({
      type: SEARCHLIGHT_CONFIRM_MODAL_OPEN,
      payload: { ...action, documentId }
    })
  }

  return (
    <div>
      <div className={classes.header}>
        <div className={classes.title}>{title}</div>
        <div className={classes.subtitle}>{subtitle}</div>
        {body.map(({ label, text }) => (
          <div
            key={`item-${label}`}
            className={classes.bodyContainer}
          >
            <div className={classes.label}>{label}:</div>
            <div className={classes.text}>{text}</div>
          </div>
        ))}
        <div className={classes.dateTime}>
          <div>DateTime:</div>
          <div>{dayjs(milliseconds).locale(intl.locale).format('lll')}</div>
        </div>
      </div>
      {images.length > 0 && (
        <div>
          {images.map(({ url }, index) => (
            <Image
              key={`image-${index}`}
              className={classes.image}
              modal
              src={url}
            />
          ))}
        </div>
      )}
      {actions.length > 0 && (
        <Carousel>
          {actions.map((action, index) => (
            <ScenarioActionItem
              key={`carouselItem-${index}`}
              action={action}
              actionTaken={actionTaken}
              onClick={onClickAction}
            />
          ))}
        </Carousel>
      )}
    </div>
  )
}

SearchLight.propTypes = {
  message: PropTypes.shape({
    collection: PropTypes.string,
    documentId: PropTypes.string
  }).isRequired
}
export default SearchLight
